import { Box, Typography, Paper, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";
import { fetchJson } from "../../../data/DynamicServiceNew/jsondynamicservice";
import SurrenderLineForm from "./surrenderLineForm";
import { imprestSurrenderLinesColumns } from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";

function ImprestSurrenderLineTable() {
  const data = JSON.parse(localStorage.getItem("SurrenderId"));
  const base_url = HRService.uri;

  const [totalAmount, setTotalAmount] = useState("KES 0.00");
  const [imprestApplicationsData, setImprestApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  async function fetchImprestApplications() {
    const params = { surrenderId: data ? data.Id : null };

    try {
      const result = await fetchJson({
        objectName: "imprestSurrenderLinesByApplicationOrSurrenderId",
        inputObjectName: "surrenderLines",
        params,
        baseUrl: base_url,
      });

      if (result) {
        const parsedData = JSON.parse(result.results);
        setImprestApplications(parsedData);

        const total = parsedData.reduce((sum, item) => sum + (item.Amount || 0), 0);
        const formattedTotal = total.toLocaleString("en-KE", {
          style: "currency",
          currency: "KES",
        });
        setTotalAmount(formattedTotal);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchImprestApplications();
  }, []);

  const actions = {
    entity: "Imprest Surrender",
    edit: { key: "EDIT", button_name: "Edit", Show_Button: false, permission: "EditPermission" },
    add: { key: "ADD", button_name: "Add", Show_Button: true, permission: "CreatePermission" },
    activateDeactivate: { key: "ACTIVATEDEACTIVATE", button_name: "Deactivate", Show_Button: false, permission: "ActivatePermission" },
    removeSurrenderLine: {
      key: "REMOVE_RELIEVER",
      button_name: "Remove Line",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2],
    },
    dataObjectForMutation: {
      isSurrenderLine: true,
      inputObjectName: "addRemoveImprestSurrenderLines",
      inputSubObjectName: "lines",
      inputFields: ["ApplicationId", "UserId", "Comments"],
      actionName: "Leave Application ",
    },
    dataObject: {
      parameters: { surrenderId: data ? data.Id : null },
      objectName: "imprestSurrenderLinesByApplicationOrSurrenderId",
      inputObjectName: "surrenderLines",
    },
    showStatus: true,
  };

  return (
    <Box m={1}>
      <Paper
        elevation={2}
        sx={{
          mb: 2,
          px: 2,
          py: 1,
          backgroundColor: "#f0f8ff",
        }}
      >
        <Grid container spacing={2} justifyContent="space-between" alignItems="center">
          <Grid item xs={6} sm={3}>
            <Typography variant="subtitle2" color="textSecondary">Total Imprest:</Typography>
            <Typography variant="h6">Ksh {parseInt(data.TotalAmount) || 0.00}</Typography>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography variant="subtitle2" color="textSecondary">Total Surrender:</Typography>
            <Typography variant="h6">{totalAmount}</Typography>
          </Grid>
        </Grid>
      </Paper>

      <DynamicTableForJson
        title="Imprest Surrender Lines"
        subtitle="View all imprest Surrenders, add or remove"
        columns={imprestSurrenderLinesColumns}
        FormComponent={SurrenderLineForm}
        actions={actions}
        base_url={base_url}
      />
    </Box>
  );
}

export default ImprestSurrenderLineTable;
